module.exports = __webpack_public_path__ + "static/media/country_gr.7fbfebb5.webp";